export default __webpack_public_path__ + "static/media/typea.b7bd094e.png";